<template>
  <component :is="isTemporarySku ? 'em' : 'span'" class="top-level" :class="{ 'is-link': isLink && isTemporarySku }">
    <template v-if="isTemporarySku">
      {{ translate('Item no missing', 'application') }}
    </template>

    <template v-else>
      <template v-if="shouldBeSplit">
        <span v-for="(skuPart, i) of splitSku" :key="i">
          {{ skuPart }}
        </span>
      </template>
      <template v-else>{{ sku }}</template>
    </template>
  </component>
</template>

<script lang="ts" setup>
import { useTranslation } from '@/composables/useTranslation'
import { shouldFormatSku } from '@/utils/tools'
import { computed } from 'vue'

const props = defineProps<{
  sku?: string
  isTemporarySku?: boolean
  isLink?: boolean
}>()

const { translate } = useTranslation()

const shouldBeSplit = computed(() => props.sku && shouldFormatSku(props.sku))
const splitSku = computed(() => (props.sku ? [props.sku?.slice(0, 2), props.sku?.slice(2, 6), props.sku?.slice(6)].filter(Boolean) : undefined))
</script>

<style lang="scss" scoped>
em:not(.is-link) {
  color: var(--disabled);
  user-select: none;
}

.top-level {
  span:not(:last-child) {
    margin-right: 0.25rem;
  }
}
</style>
